import { ICONS } from 'shared/constants/images';
import { Icon } from '../icon/icon';
import cls from './score-square.module.scss';

type Direction = 'str' | 'inv';

export interface ScoreSquareProps {
  score?: number | null;
  maxScore?: number | null;
  isSmall?: boolean;
  direction?: Direction;
  isLocked?: boolean;
}

export const getScoreColor = (
  score?: number | null,
  dir: Direction = 'str',
  maxScore?: number | null
) => {
  if (score == null) {
    return cls.gray;
  }
  if (maxScore != null && maxScore > 0) {
    const percentage = score / maxScore;
    if (dir === 'inv') {
      if (percentage <= 0.3) return cls.green;
      if (percentage <= 0.7) return cls.orange;
      return cls.red;
    } else {
      if (percentage >= 0.8) return cls.green;
      if (percentage >= 0.4) return cls.orange;
      return cls.red;
    }
  }

  if (dir === 'inv') {
    if (score <= 3) return cls.green;
    if (score <= 7) return cls.orange;
    return cls.red;
  } else {
    if (score >= 8) return cls.green;
    if (score >= 4) return cls.orange;
    return cls.red;
  }
};

export const ScoreSquare: React.FC<ScoreSquareProps> = ({
  score,
  maxScore,
  direction = 'str',
  isSmall = false,
  isLocked = false,
}: ScoreSquareProps) => {
  if (isLocked) {
    return (
      <div
        className={`${cls.scoreSquare} ${isSmall ? cls.small : ''} ${cls.gray}`}
      >
        <Icon pathToIcon={ICONS.lockGray} size={16} />
      </div>
    );
  }

  if (score == null) {
    return (
      <div
        className={`${cls.scoreSquare} ${cls.gray} ${isSmall ? cls.small : ''}`}
      >
        -
      </div>
    );
  }

  return (
    <div
      className={`${cls.scoreSquare} ${getScoreColor(score, direction, maxScore)} ${isSmall ? cls.small : ''}`}
    >
      {score % 1 === 0 ? score : score.toFixed(1)}
    </div>
  );
};
